/**
 * avatars/items/beard.js
 * Xây dựng hình học 3D cho createBeard
 */

import * as THREE from 'three';
import { BEARD_TYPES } from './item-types.js';

export { BEARD_TYPES };

export function createBeard(lib, type, headSize, color = '#94a3b8') {
  const beardGroup = new THREE.Group();
  beardGroup.name = `Beard_${type}`;

  if (!type || type === 'none') return beardGroup;

  const beardMat = new THREE.MeshStandardMaterial({
    color: color || '#94a3b8',
    roughness: 0.85,
    metalness: 0.08
  });
  const silverMat = new THREE.MeshStandardMaterial({
    color: '#e2e8f0',
    roughness: 0.8,
    metalness: 0.12
  });
  lib.disposables.push(beardMat, silverMat);

  if (type === 'elder_beard') {
    // RÂU DÀI MÀU XÁM BẠC CHO NGƯỜI GIÀ (ELDER BEARD) - GẮN VÀO CẰM DƯỚI HEADGROUP
    // 1. Ria mép lão trượng nằm ngang trên môi trên
    const stacheGeo = new THREE.BoxGeometry(headSize * 0.54, headSize * 0.13, headSize * 0.12);
    const stache = new THREE.Mesh(stacheGeo, beardMat);
    stache.position.set(0, headSize * 0.32, headSize * 0.52);
    beardGroup.add(stache);

    // Điểm xuyết hai chỏm ria bạc vểnh nhẹ sang hai mép
    [-1, 1].forEach((side) => {
      const curlGeo = new THREE.BoxGeometry(headSize * 0.14, headSize * 0.1, headSize * 0.1);
      const curl = new THREE.Mesh(curlGeo, silverMat);
      curl.position.set(side * headSize * 0.3, headSize * 0.28, headSize * 0.51);
      curl.rotation.z = -side * 0.2;
      beardGroup.add(curl);
      lib.disposables.push(curlGeo);
    });

    // 2. Chỏm râu cằm chính ôm sát cằm dưới
    const chinBaseGeo = new THREE.BoxGeometry(headSize * 0.46, headSize * 0.22, headSize * 0.2);
    const chinBase = new THREE.Mesh(chinBaseGeo, beardMat);
    chinBase.position.set(0, headSize * 0.06, headSize * 0.48);
    beardGroup.add(chinBase);

    // 3. Tầng 1 chòm râu dài buông dưới cằm
    const l1Geo = new THREE.BoxGeometry(headSize * 0.4, headSize * 0.26, headSize * 0.16);
    const l1 = new THREE.Mesh(l1Geo, silverMat);
    l1.position.set(0, -headSize * 0.12, headSize * 0.44);
    l1.rotation.x = 0.08;
    beardGroup.add(l1);

    // 4. Tầng 2 chòm râu buông giữa ngực
    const l2Geo = new THREE.BoxGeometry(headSize * 0.32, headSize * 0.28, headSize * 0.13);
    const l2 = new THREE.Mesh(l2Geo, beardMat);
    l2.position.set(0, -headSize * 0.34, headSize * 0.4);
    l2.rotation.x = 0.12;
    beardGroup.add(l2);

    // 5. Tầng 3 đuôi râu nhọn dần
    const l3Geo = new THREE.BoxGeometry(headSize * 0.2, headSize * 0.24, headSize * 0.1);
    const l3 = new THREE.Mesh(l3Geo, silverMat);
    l3.position.set(0, -headSize * 0.54, headSize * 0.36);
    l3.rotation.x = 0.15;
    beardGroup.add(l3);

    // 6. Đuôi chóp râu tiên ông thanh thoát
    const tipGeo = new THREE.BoxGeometry(headSize * 0.1, headSize * 0.16, headSize * 0.08);
    const tip = new THREE.Mesh(tipGeo, beardMat);
    tip.position.set(0, -headSize * 0.7, headSize * 0.32);
    tip.rotation.x = 0.18;
    beardGroup.add(tip);

    // 7. Râu quai nón hai bên hàm ôm sát má
    [-1, 1].forEach((side) => {
      const sideGeo = new THREE.BoxGeometry(headSize * 0.12, headSize * 0.3, headSize * 0.38);
      const sideMesh = new THREE.Mesh(sideGeo, beardMat);
      sideMesh.position.set(side * headSize * 0.46, headSize * 0.18, headSize * 0.22);
      beardGroup.add(sideMesh);
      lib.disposables.push(sideGeo);
    });

    lib.disposables.push(stacheGeo, chinBaseGeo, l1Geo, l2Geo, l3Geo, tipGeo);
  } else {
    // Râu cằm ngắn mặc định
    const chinGeo = new THREE.BoxGeometry(headSize * 0.36, headSize * 0.18, headSize * 0.14);
    const chin = new THREE.Mesh(chinGeo, beardMat);
    chin.position.set(0, headSize * 0.06, headSize * 0.5);
    beardGroup.add(chin);
    lib.disposables.push(chinGeo);
  }

  return beardGroup;
}
